import { usePost } from '../utils/reactQuery';
import { ApiRoutesEnum } from '../utils/routes';

export const useUpdateCandidateNote = () => {
  return usePost({
    url: ApiRoutesEnum.candidateUpdateNote,
  });
};
